var React = require('react');

function J1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"J1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("rect",{"x":"27.76","y":"0.96","width":"23.07","height":"80.03","transform":"translate(-3.96 4.2) rotate(-5.83)","fill":"#f47643"})),React.createElement("path",{"d":"M28.34,50.42l9.29,31.35A33,33,0,0,1,0,58.7Z","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

J1.defaultProps = {"viewBox":"0 0 54.84 82.33"};

module.exports = J1;

J1.default = J1;
